export interface NewsItem {
  id: string;
  categoryId: string;
  title: string;
  summary: string;
  timeText: string;
  heat: string;
  isHot?: boolean;
  tag: string;
}

export interface Category {
  id: string;
  name: string;
  desc: string;
  icon: string;
}

export const categoryTabs = [
  { id: "all", name: "全部速报" },
  { id: "star", name: "明星新瓜" },
  { id: "variety", name: "综艺现场" },
  { id: "social", name: "社会热点" },
  { id: "meme", name: "网络爆梗" },
  { id: "tech", name: "科技圈" },
  { id: "work", name: "职场瓜" },
];

export const categories: Category[] = [
  { id: "star", name: "明星新瓜", desc: "艺人事态最新动向与作品动态还原", icon: "ri-star-line" },
  { id: "variety", name: "综艺现场", desc: "真人秀与晚会的幕后瞬间与高能名场面", icon: "ri-camera-line" },
  { id: "social", name: "社会热点", desc: "城市话题与民生事件的最新进展梳理", icon: "ri-fire-line" },
  { id: "meme", name: "网络爆梗", desc: "社交平台刷屏热词与热梗的来龙去脉", icon: "ri-chat-smile-line" },
  { id: "tech", name: "科技圈", desc: "数码发布与互联网行业的重磅消息", icon: "ri-flashlight-line" },
  { id: "work", name: "职场瓜", desc: "求职裁员与公司八卦的现场直击", icon: "ri-briefcase-line" },
];

export const latestFeed: NewsItem[] = [
  { id: "n01", categoryId: "star", title: "林晚晴新剧开拍首日路透曝光 对手戏演员成热议焦点", summary: "片场外流出的高清路透显示两位主演对手戏张力十足，制片方暂未回应阵容传闻。", timeText: "刚刚", heat: "186.4万", isHot: true, tag: "爆" },
  { id: "n02", categoryId: "social", title: "某商圈跨年夜人流破纪录 地铁临时加开夜班疏运", summary: "现场直击显示地铁站启用临时闸机，工作人员彻夜值守引导人群有序离场。", timeText: "3分钟前", heat: "92.1万", isHot: true, tag: "热" },
  { id: "n03", categoryId: "variety", title: "《周末突击队》花絮释出 陈屿川即兴反应成全网名场面", summary: "节目组放出未播花絮，一段即兴互动在短视频平台单日播放破千万。", timeText: "9分钟前", heat: "240.7万", isHot: true, tag: "爆" },
  { id: "n04", categoryId: "tech", title: "新旗舰发布会定档 真机渲染图提前遭泄漏", summary: "多家媒体放出据称是实拍的真机渲染图，供应链消息称备货量较上代翻倍。", timeText: "14分钟前", heat: "67.3万", tag: "新" },
  { id: "n05", categoryId: "meme", title: "\u201c已老实\u201d刷屏朋友圈 这个热梗到底从哪来", summary: "从直播间到职场群的万能回应体，追溯它一周内爆红的完整时间线。", timeText: "22分钟前", heat: "58.9万", tag: "梗" },
  { id: "n06", categoryId: "star", title: "周景川工作室深夜发声明 回应网络不实传闻", summary: "声明措辞强硬，称将对恶意造谣账号启动法律程序，网友却各执一词。", timeText: "36分钟前", heat: "301.2万", isHot: true, tag: "爆" },
  { id: "n07", categoryId: "work", title: "互联网大厂年终调整疑云 员工晒出的内部信引热议", summary: "一张被转发的内部信截图掀起讨论潮，HR部门回应称\u201c以官方通知为准\u201d。", timeText: "52分钟前", heat: "45.5万", tag: "职" },
  { id: "n08", categoryId: "variety", title: "音乐盛典直播中断 舞台技术故障现场画面流出", summary: "直播中途画面一度黑屏约九十秒，主办方随后发布致歉并说明原因。", timeText: "1小时前", heat: "88.6万", tag: "热" },
  { id: "n09", categoryId: "social", title: "城市夜跑团意外走红 领队的一句口头禅带火整条街", summary: "一支民间夜跑团的日常被路人拍下，领队的口头禅让这条沿江路线出圈。", timeText: "2小时前", heat: "39.8万", tag: "暖" },
  { id: "n10", categoryId: "meme", title: "年度流行语盘点抢先看 这些词条你都用过几个", summary: "语言生活观察机构公布候选词单，网络语境与传统表达呈现新融合。", timeText: "3小时前", heat: "72.0万", tag: "盘点" },
  { id: "n11", categoryId: "tech", title: "旧款旗舰开启官降 渠道报价一夜跳水引抢购", summary: "多电商平台同步调价，部分配色迅速售罄，二手市场也随之波动。", timeText: "4小时前", heat: "51.3万", tag: "新" },
  { id: "n12", categoryId: "star", title: "金秋颁奖礼红毯生图刷屏 造型师连夜解读心机", summary: "多位艺人红毯造型冲上热搜，造型师下场逐套拆解配色与剪裁巧思。", timeText: "5小时前", heat: "134.5万", isHot: true, tag: "热" },
];

export interface HotSpot {
  id: string;
  place: string;
  title: string;
  summary: string;
  reads: string;
  up: string;
  image: string;
}

export const hotSpots: HotSpot[] = [
  {
    id: "h01",
    place: "全网现场",
    title: "周景川声明事件 三个关键点仍未解释",
    summary: "声明发布已过一夜，发酵从饭圈蔓延到路人盘。仍有三个关键疑点悬而未决，我们来逐条梳理目前能确认与不能确认的信息。",
    reads: "842万",
    up: "6.3万",
    image: "https://readdy.ai/api/search-image?query=cinematic%20editorial%20still%20of%20a%20press%20microphone%20and%20warm%20stage%20spotlight%20glow%20against%20deep%20amber%20background%2C%20journalism%20breaking%20news%20mood%2C%20soft%20shadow%2C%20dramatic%20warm%20lighting%2C%20high%20detail%2C%20no%20people%20faces&width=1200&height=800&seq=gossip-h1&orientation=landscape",
  },
  {
    id: "h02",
    place: "发布会现场",
    title: "新机真机图全泄露 摄像头模组成最大争论点",
    summary: "距离发布还有一周，真机渲染图却先一步跑遍全网。最受争议的摄像头设计究竟是创新还是翻车，供应链工程师给出了中立拆解。",
    reads: "631万",
    up: "4.8万",
    image: "https://readdy.ai/api/search-image?query=editorial%20product%20photography%20of%20a%20sleek%20smartphone%20on%20warm%20terracotta%20backdrop%20with%20soft%20studio%20lighting%2C%20modern%20minimalist%20teardown%20mood%2C%20refined%20shadows%2C%20high%20detail&width=1200&height=800&seq=gossip-h2&orientation=landscape",
  },
  {
    id: "h03",
    place: "颁奖礼后台",
    title: "红毯生图大赏 谁的造型让你直呼意外",
    summary: "一夜之间生图与精修图的对比图满屏飞，造型团队连夜回应。我们整理了讨论度最高的五套造型，附上造型师的独家拆解。",
    reads: "510万",
    up: "3.1万",
    image: "https://readdy.ai/api/search-image?query=elegant%20editorial%20concept%20of%20flowing%20evening%20fabric%20in%20warm%20gold%20and%20burgundy%20tonality%20under%20soft%20red%20carpet%20glow%2C%20fashion%20awards%20mood%2C%20no%20person%2C%20abstract%20elegant&width=1200&height=800&seq=gossip-h3&orientation=landscape",
  },
  {
    id: "h04",
    place: "商圈现场",
    title: "跨年夜人从众 现场疏导背后的细节被点赞",
    summary: "当人流数据逼近预警线，现场如何靠一次次临时调度守住安全底线？几位志愿者的讲述，还原了那个紧张又不失温度的夜晚。",
    reads: "423万",
    up: "2.7万",
    image: "https://readdy.ai/api/search-image?query=atmospheric%20night%20city%20street%20with%20warm%20lantern%20and%20neon%20glow%20crowd%20silhouette%20mood%2C%20editorial%20documentary%20style%2C%20festive%20warm%20tones%2C%20soft%20bokeh%2C%20no%20clear%20faces&width=1200&height=800&seq=gossip-h4&orientation=landscape",
  },
];

export interface TopEntry {
  id: string;
  title: string;
  heat: string;
  trend: "up" | "down" | "new";
  tag: string;
}

export const topList: TopEntry[] = [
  { id: "t01", title: "周景川工作室深夜声明 关键词指向明确", heat: "3012万", trend: "new", tag: "爆" },
  { id: "t02", title: "\u201c已老实\u201d热梗彻底出圈 一周时间线全记录", heat: "1987万", trend: "up", tag: "梗" },
  { id: "t03", title: "林晚晴新剧路透 对手戏演员身份引猜疑", heat: "1564万", trend: "up", tag: "瓜" },
  { id: "t04", title: "音乐盛典直播中断90秒 官方回应来了", heat: "1210万", trend: "up", tag: "热" },
  { id: "t05", title: "新旗舰真机图泄漏 摄像头设计引发阵营大战", heat: "976万", trend: "down", tag: "新" },
  { id: "t06", title: "颁奖礼红毯生图刷屏 造型师下场拆解", heat: "743万", trend: "down", tag: "美" },
  { id: "t07", title: "跨年夜地铁加开夜班 守护你的每一次回家", heat: "612万", trend: "up", tag: "暖" },
  { id: "t08", title: "年度流行语候选公布 你被哪个词扎到了", heat: "488万", trend: "down", tag: "盘点" },
];

export interface TimelineEntry {
  time: string;
  title: string;
  desc: string;
}

export const dailyTimeline: TimelineEntry[] = [
  { time: "00:12", title: "周景川工作室声明发出", desc: "措辞强硬的声明上线，十分钟内转发破百万。" },
  { time: "01:40", title: "多方账号跟进点评", desc: "业内与营销号陆续下场，话题登上社交平台热榜首位。" },
  { time: "08:30", title: "工作室追加律师函内容", desc: "点名的造谣账号范围进一步明确，维权路径清晰化。" },
  { time: "11:05", title: "事件当事人首次发声", desc: "一句\u201c清者自清\u201d再度引爆评论区，热度二次攀升。" },
  { time: "15:20", title: "舆情热度回落进入收尾", desc: "讨论从站队转向取证与事实核查，理性声音占比上升。" },
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faqItems: FaqItem[] = [
  { q: "最快吃瓜每天更新几次内容？", a: "我们的速报覆盖全天主要热点时段，事件有重大进展时会在\u201c刚刚发生\u201d栏实时更新，第一时间把最新动态推送到你眼前，不遗漏关键节点。" },
  { q: "你们的信息来源可靠吗？", a: "我们坚持\u201c信源优先\u201d原则，只汇总公开的官方公告、媒体报道与现场画面，并对高争议内容标注\u201c待核实\u201d，帮你理性吃瓜而不是被带节奏。" },
  { q: "遇到假消息会怎么处理？", a: "一经确认存在失实，我们会第一时间在原文发布更正说明并标注来源。欢迎在评论区或联系邮箱提供线索，核实后会补全最新进展。" },
  { q: "网站是免费阅读的吗？", a: "是的，所有现场直击、今日新瓜与速报内容均免费开放，无需注册即可阅读，我们靠内容本身说话，不做付费解锁。" },
  { q: "如何在移动端顺畅追热点？", a: "本站采用移动端优先设计，顶部菜单可在手机上折叠展开，配合锚点导航与返回顶部按钮，刷瓜体验与电脑端同样流畅。" },
  { q: "可以投稿爆料或提供线索吗？", a: "非常欢迎。你可以通过页脚的联系邮箱提供新闻线索，附上时间、地点与尽量完整的信息，我们会依据真实性与公共价值评估跟进。" },
];

export interface Testimonial {
  name: string;
  role: string;
  text: string;
}

export const testimonials: Testimonial[] = [
  { name: "阿柚", role: "追热点五年的老瓜民", text: "别的号还在搬旧闻，这里已经把现场细节和来龙去脉捋清楚了，关键时间点一个不落，刷完就能在群里当课代表。" },
  { name: "Momo酱", role: "媒体行业从业者", text: "做线索核实时常参考这里的信源整理，标注\u201c待核实\u201d的做法很专业，比很多所谓快讯靠谱得多。" },
  { name: "老白", role: "晚高峰通勤党", text: "每天通勤几分钟就能把今日新瓜补完，时间线清楚、克制不煽情，是我唯一置顶的速报账号。" },
];